import React, { useState } from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
// import { BigNumber } from 'bignumber.js'
import SortPets from '../Sort'
import { TokauTokenOptions, BscTokenOptions } from '../../constants/artwork'
import { MARKETMULTITOKEN, MARKETTYPEV3 } from '../../constants/bakery/nft'
// import useYam from '../../hooks/bakery/useYam'
// import { exchangeNFTsGetNftQuotes } from '../../sushi/exchangeNFTs'
// import { userNftAddress } from '../../userType/userNftAddress'
// import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'

// components
import { Input as NumericalInput } from '../NumericalInput'

const StyledInput = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.bsBg37};
  border-radius: 8px;
  height: 48px;
  padding: 0 16px;
  & > input {
    font-family: 'Roboto-Medium';
    color: ${({theme}) => theme.bsText34};
  }
`
const BakeText = styled.div`
  color: #d6a485;
`
const StyledLimitButton = styled.button`
  height: 28px;
  background-color: ${({ theme }) => theme.primary5};
  border: 1px solid ${({ theme }) => theme.primary5};
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-family: Baloo Da;
  font-weight: 500;
  cursor: pointer;
  margin-right: 0.2rem;
  color: ${({ theme }) => theme.primaryText1};
  :hover {
    border: 1px solid ${({ theme }) => theme.primary1};
  }
  :focus {
    border: 1px solid ${({ theme }) => theme.primary1};
    outline: none;
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-right: 0.2rem;
  `};
`


interface BakePriceInputProps {
  value: string,
  onChange: (value: string) => void,
  onChangeToken: (value: string) => void,
  max?: string,
  min?: string,
  symbol?: string,
  placeholder?: string,
  marketType?: string,
  onSelectMin?: () => void,
  onSelectMax?: () => void
}

const BakePriceInput: React.FC<BakePriceInputProps> = ({
  value,
  symbol,
  onChange,
  onChangeToken,
  max,
  min,
  onSelectMax,
  onSelectMin,
  placeholder,
  marketType
}) => {
  // const [curTab, setCurTab] = useState(TokenOptions[0])

  // const sushi = useYam()
  // let nftAddress = userNftAddress(sushi, marketType)
  // let nftContract = multiTokenExchangeNftContract(sushi, marketType)
  // console.log("---nftAddress-->",nftAddress)
  // console.log("---nftContract-->",nftContract)

  // const getNftQuotes = useCallback(async() => {
  //   const nftQuotes = await exchangeNFTsGetNftQuotes(nftContract,nftAddress)
  //   console.log("---nftQuotes-->",nftQuotes)
  // }, [exchangeNFTsGetNftQuotes])

  // useEffect(() => {
  //   getNftQuotes()
  // }, [])
  let Tokens: any[] = []
  switch (marketType) {
    case MARKETTYPEV3.BAKERYARTWORKV3:
    case MARKETTYPEV3.BAKERYBSCARTWORKV3:
      Tokens = BscTokenOptions
      break;
    case MARKETMULTITOKEN.TOKAUMULTITOKEN:
    case MARKETTYPEV3.TOKAUV3:
      Tokens = TokauTokenOptions
      break;
    default:
      break;
  }


  const [curTab, setCurTab] = useState(Tokens[0])

  return (
    <StyledInput>
      <NumericalInput
        className="token-price-input"
        value={value}
        style={{ marginRight: 5 }}
        onUserInput={val => {
          onChange(val)
        }}
        placeholder={placeholder}
      />
      <>
        {min && <StyledLimitButton onClick={onSelectMin}>Min</StyledLimitButton>}
        {max && <StyledLimitButton onClick={onSelectMax}>MAX</StyledLimitButton>}
      </>
      <BakeText>
        {
          marketType && [
            MARKETMULTITOKEN.TOKAUMULTITOKEN,
            MARKETTYPEV3.TOKAUV3,
            MARKETTYPEV3.BAKERYBSCARTWORKV3,
            MARKETTYPEV3.BAKERYARTWORKV3
          ].includes(marketType) ?
          <SortPets
            height={48}
            bg="none"
            margin={'0 -16px 0 0'}
            wd="110px"
            curSelect={curTab}
            options={Tokens}
            updateData={(d: any) => {
              setCurTab(d)
              onChangeToken(d.name)
            }}
          ></SortPets>
          : <Text fontWeight={700}>{symbol}</Text>
        }
        
      </BakeText>
    </StyledInput>
  )
}

export default BakePriceInput
